<style lang='less' scoped>
.project-list {
   &__item {
      display: flex;
      align-items: center;
      padding: 6px 2px;
      border-radius: 8px;
      cursor: pointer;
      svg {
         flex-shrink: 0;
      }
      .item__title {
         flex: 1;
         padding-left: 12px;
         font-size: 12px;
         color: #222327;
         line-height: 18px;
         font-weight: bold;
         display: -webkit-box;
         -webkit-box-orient: vertical;
         -webkit-line-clamp: 2;
         overflow: hidden;
      }
      &--acitve {
         background-color: #f5f7fd;
         .item__title {
            color: #4680ff;
         }
      }
   }
}
.tree-text{ width: 24px; height: 24px; border: 1px solid #409EFF; border-radius: 50%; line-height: 24px; text-align: center; color: #409EFF; font-size: 12px; }
.tree-img{ width: 24px; height: 24px; }
</style>

<template>
   <div class="project-list">
      <div
         class="project-list__item"
         :class="[
            item[props.id] == modelValue ? 'project-list__item--acitve' : false,
         ]"
         v-for="item in data"
         @click="$emit('update:modelValue', item[props.id]);$emit('itemClick',item)"
         :key="item[props.id]"
      >
         <!-- <svg-icon name="project-collapse" :size="24"></svg-icon> -->
         <img src="@/assets/images/project.png" alt="" class="tree-img" v-if="isImg">
         <span class="tree-text" v-else>{{item.id}}</span>
         <div class="item__title">
            <el-tooltip
               :show-after="1000"
               class="item"
               effect="dark"
               :content="item[props.label]"
               placement="top-start"
            >
               <div class="tree-title__text">
                  {{ item[props.label] }}
               </div>
            </el-tooltip>
         </div>
      </div>
   </div>
</template>

<script lang='ts'>
import { defineComponent, PropType, reactive } from "vue";
export default defineComponent({
   props: {
      modelValue: {
         type: [String, Number],
         default: "",
      },
      data: {
         type: Array as PropType<any[]>,
         default: () => [],
      },
      isImg:{
         type: Boolean,
         default: false,
      },
      props: {
         type: Object,
         default: () => {
            return {
               label: "projectName",
               id: "id",
            };
         },
      },
   },
   setup() {
      return {};
   },
   /****************************************************************
    *
    *
    *
    ***************************************************************/
});
</script>